import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from './icons';
export const SocialProof: React.FC = () => {
  const testimonials = [{
    quote: "He has the energy of a puppy again! My 11-year-old Lab was struggling with stairs. After 3 weeks on the Longevity Protocol, he's chasing squirrels again. Best $37 I ever spent.",
    name: 'Sarah M.',
    location: 'Austin, TX',
    result: 'Visible mobility in 21 days'
  }, {
    quote: 'Saved me $200 a month. I was paying for a fresh food subscription that was killing my budget. This book showed me how to get better results using Costco items. My vet was shocked at his bloodwork.',
    name: 'Mark J.',
    location: 'Denver, CO',
    result: 'Healthier coat & $2,400 yearly savings'
  }, {
    quote: 'The peace of mind is priceless. I was so worried about cancer. This guide made it so simple to understand what to avoid. Her breath is better, her eyes are clearer, and her energy is stable.',
    name: 'Linda D.',
    location: 'San Diego, CA',
    result: 'Improved gut health'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-20 px-6 sm:px-8 lg:px-12 max-w-6xl mx-auto" data-id="element-260">
      <div className="text-center mb-16" data-id="element-261">
        <span className="text-xs font-bold tracking-[0.2em] text-gold uppercase block mb-4" data-id="element-262">
          Real Results
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl text-forest-dark" data-id="element-263">
          Join thousands of proactive dog parents.
        </h2>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid md:grid-cols-3 gap-8" data-id="element-264">
        {testimonials.map((t, i) => <motion.div key={i} variants={itemVariants} className="bg-cream-light p-8 rounded-xl border border-gold/30 shadow-sm flex flex-col h-full" data-id="element-265">
            <div className="flex gap-1 mb-6" data-id="element-266">
              {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 text-gold fill-gold" data-id="element-267" />)}
            </div>
            <p className="text-charcoal/80 italic mb-6 flex-grow text-sm sm:text-base leading-relaxed" data-id="element-268">
              "{t.quote}"
            </p>
            <div className="mt-auto" data-id="element-269">
              <p className="font-serif font-bold text-forest-dark text-lg" data-id="element-270">
                {t.name}
              </p>
              <p className="text-xs text-charcoal/50 uppercase tracking-wider mb-4" data-id="element-271">
                {t.location}
              </p>
              <div className="bg-forest/5 inline-block px-3 py-1.5 rounded text-xs font-bold text-forest-dark border border-forest/10" data-id="element-272">
                Result: {t.result}
              </div>
            </div>
          </motion.div>)}
      </motion.div>
    </section>;
};